<header class="group-list-header">
  <div class="group-list-header__crumbs">
    <app-breadcrumb [home]="home" [items]="breadcrumbs" [favoritable]="false"></app-breadcrumb>
  </div>
  <div class="group-list-header__top">
    <div class="group-list-header__title">
      <h1>Grupos de permissão</h1>
      <p>O que cada tipo de usuário pode ver e fazer. Um usuário pode estar em mais de um grupo.</p>
    </div>
    @if (showSearch()) {
      <div class="group-list-header__search">
        <app-search
          placeholder="Buscar grupo"
          size="small"
          [realTime]="true"
          [clearable]="true"
          [value]="query()"
          (sendSearch)="queryChange.emit($event)"></app-search>
      </div>
    }
    @if (canCreate()) {
      <app-button
        [id]="'add-group'"
        label="Novo grupo"
        icon="plus"
        type="button"
        size="medium"
        [noMargin]="true"
        [fitContent]="true"
        (sendButtonClick)="create.emit()"></app-button>
    }
  </div>
</header>
